import {
  Layers, SlidersHorizontal, Box, Flame, CloudRain, Wrench
} from "lucide-react";

const products = [
  { id: "pvc-walls", name: "PVC Dividing Walls", desc: "Heavy-duty partition systems", icon: Layers },
  { id: "sliding-curtains", name: "Sliding Curtains", desc: "Flexible sliding solutions", icon: SlidersHorizontal },
  { id: "industrial-covers", name: "Industrial Covers", desc: "Protective equipment covers", icon: Box },
  { id: "welding-screens", name: "Welding Screens", desc: "UV-protective safety screens", icon: Flame },
  { id: "weather-protection", name: "Weather Protection", desc: "Rain, wind & UV shielding", icon: CloudRain },
  { id: "custom", name: "Custom Solution", desc: "Bespoke textile fabrication", icon: Wrench },
];

export default function StepProduct({ form, setForm }) {
  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        What do you need?
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Select the product type for your project.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map((p) => {
          const selected = form.product_type === p.id;
          return (
            <button
              key={p.id}
              type="button"
              data-testid={`product-select-${p.id}`}
              onClick={() => setForm((prev) => ({ ...prev, product_type: p.id, layout: "" }))}
              className={`text-left p-5 border transition-all duration-200 group ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-10 h-10 flex items-center justify-center shrink-0 ${
                    selected ? "bg-[#FF5722]/20" : "bg-[#1F1F1F] group-hover:bg-[#FF5722]/10"
                  }`}
                >
                  <p.icon size={20} className={selected ? "text-[#FF5722]" : "text-[#A3A3A3] group-hover:text-[#FF5722]"} />
                </div>
                <div>
                  <p className={`font-bold text-sm ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                    {p.name}
                  </p>
                  <p className="text-xs text-[#A3A3A3] mt-1">{p.desc}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
